import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
import ButtonBase from 'src/components/Button';
import { WithTestId } from 'src/types/utils';
const Button = styled(ButtonBase)`
  font-size: 16px;
`;
type Props = WithTestId<{
  onSkip: () => void;
  id?: string;
  className?: string;
}>;
const SkipButton = ({
  onSkip,
  id,
  className,
  'data-testid': dataTestId
}: Props) => {
  const {
    t
  } = useTranslation();
  return <Button className={className} id={id ?? 'auth-step-skip-button'} onClick={onSkip} variant='text' color='secondary' data-testid={dataTestId} data-sentry-element="Button" data-sentry-component="SkipButton" data-sentry-source-file="SkipButton.tsx">
      {t('COMMON__SKIP')}
    </Button>;
};
export default SkipButton;